<template>
  <b-modal
    id="modal-manage-social"
    scrollable
    no-close-on-esc
    no-close-on-backdrop
    @show="modalShow"
    @hidden="modalHidden"
  >
    <template #modal-header>
      <div class="d-inline-flex justify-content-between w-100">
        <div>
          <TitleModal :label="$t('engine.manageSocial.lblTitle', languageEngine)" />
          <div class="fs-sa-12 mt-5" style="color: #53585D;">{{$t('engine.manageSocial.lblTitleDesc', languageEngine)}}</div>
        </div>
        <div class="d-flex align-items-center">
          <div class="icon-question fs-16">
            <i class="fal fa-question-circle"></i>
          </div>
          <div
            @click="closeModal()"
            type="button"
            aria-label="Close"
            id="close-modal-manage-header-social"
            class="ml-10 icon-close-modal fs-24"
          >
            <i class="fal fa-times"></i>
          </div>
        </div>
      </div>
    </template>
      <template>
        <b-overlay variant="white" :opacity="0.8" :show="isUploading">
          <div class="setting-social" v-if="socials">
            <div
              v-for="item in Object.keys(socials).filter((key) => socialsTypeSettingNormal.includes(key))"
              :key="`${item}_social`"
              class="social-item"
            >
              <div class="social-item-wrap w-100">
                <div class="social-widget">
                  <component :is="`${item}_custom`" v-if="item != 'lazada'"/>
                  <img src="/images/icon/lazada-square-multicolor.png" width="34" height="34" v-else/> <!-- logo lazada ตรงนี้ใช้ img เพราะ พอใช้เป็น svg แล้วเจอปัญหาสีเพี้ยนในบางครั้ง ซึ่งเจอเฉพาะแค่ใน modal นี้ -->
                </div>

                <!-- from input -->
                <div class="w-100 mx-15 social-input">
                  <b-form-input
                    v-if="item"
                    v-model="socials[item].link"
                    :placeholder="genUrlPlaceHolder(item)"
                    @keyup="inputSocialKeyup(item)"
                  ></b-form-input>

                </div>

                <div class="social-switcher">
                  <Switcher v-model="socials[item].isEnable" :disabled="!socials[item].link || socials[item].link == '' || $v.socials[item].$invalid"/>
                </div>

              </div>
              <small v-if="$v.socials[item].$invalid" class="text-danger mt-5" style="margin-left: 49px;">{{$t('engine.manageSocial.errorUrlFormat', languageEngine)}}</small>
            </div>

            <hr class="my-0" />

            <!------- Line ------->
            <div class="social-item-line py-15">
              <div class="social-item">
                <div class="social-item-wrap">
                  <div class="social-widget"><socialLine /></div>
                  <div class="w-100 mx-15 social-input">
                    <b-form-input
                      v-model="socials['line'].username"
                      :placeholder="$t('engine.manageSocial.plcLine', languageEngine)"
                      @keyup="inputSocialKeyup('line')"
                      @blur="inputLineOnBlur"
                    ></b-form-input>
                  </div>
                  <div class="social-switcher">
                    <Switcher v-model="socials['line'].isEnable" :disabled="!socials['line'].username || socials['line'].username == ''"/>
                  </div>
                </div>
                <small v-if="lineStringUrlCheck()" class="text-danger mt-5" style="margin-left: 49px;">{{$t('engine.manageSocial.lblLineInvalid', languageEngine)}}</small>
              </div>
              <div class="setting-line">
                <TitleSetting :tag="'div'" :label="$t('engine.manageSocial.lblSettingLine', languageEngine)" />
                <b-row class="mt-10">
                  <b-col cols="4">
                    <div class="fs-sa-12">{{$t('engine.manageSocial.lblTypeLineID', languageEngine)}}</div>
                  </b-col>
                  <b-col>
                    <b-form-group v-slot="{ ariaDescribedby }" class="mb-0">
                      <b-form-radio
                        v-model="socials['line'].userType"
                        :aria-describedby="ariaDescribedby"
                        class="fs-sa-12"
                        name="line-type"
                        value="lineid"
                        >{{$t('engine.manageSocial.lblLineID', languageEngine)}}</b-form-radio
                      >
                      <b-form-radio
                        v-model="socials['line'].userType"
                        :aria-describedby="ariaDescribedby"
                        class="fs-sa-12"
                        name="line-type"
                        value="lineadd"
                        >{{$t('engine.manageSocial.lblLineOfficial', languageEngine)}}</b-form-radio
                      >
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row v-if="socials['line']" class="mt-10">
                  <b-col cols="4">
                    <div class="fs-sa-12">{{$t('engine.manageSocial.lblShowQR', languageEngine)}}</div>
                    <div class="fs-sa-12 text-muted">({{$t('engine.manageSocial.lblShowQRHint', languageEngine)}})</div>
                  </b-col>
                  <b-col>
                    <b-form-checkbox v-model="socials['line'].isEnableQRcode"/>
                  </b-col>
                </b-row>
                <FormGroupHorizontal class="mt-gd-2"
                  :label="`Line ID Text color`"
                  :split="'4:auto'"
                  labelValign="center"
                  :contentClass="'position-relative'"
                >
                  <PalettePicker :data="lineColor" :boundary="'scrollParent'" @input="changeLineColor"/>
                </FormGroupHorizontal>
              </div>

            </div>

            <hr class="my-0" />

            <!------- WeChat ------->
              <div class="social-item-wechat pt-15">
                <div class="social-item">
                  <div class="social-item-wrap">
                    <div class="social-widget"><socialWechat /></div>
                    <div class="w-100 mx-15 social-input">
                      <b-form-input
                        v-model="socials['wechat'].username"
                        :placeholder="$t('engine.manageSocial.plcWechat', languageEngine)"
                        @keyup="inputSocialKeyup('wechat')"
                      ></b-form-input>
                    </div>
                    <div class="social-switcher">
                      <Switcher v-model="socials['wechat'].isEnable" :disabled="!socials['wechat'].username || socials['wechat'].username == ''"/>
                    </div>
                  </div>
                </div>
                <div class="setting-wechat w-100">
                  <TitleSetting :tag="'div'" :label="$t('engine.manageSocial.lblSettingWechat', languageEngine)" />
                  <b-row>
                    <b-col cols="4" class="mt-10 d-flex justify-content-center align-items-center" v-if="socials['wechat'].qrcodeImage || fileUpload.length">
                      <img style="width: 100px; height: 100px;" :src="socials['wechat'].qrcodeImage.replace('{{size}}', '0')" v-if="fileUpload.length <= 0"/>
                      <img style="width: 100px; height: 100px;" :src="genUrlPreview(fileUpload[0])" v-if="fileUpload.length > 0" />
                    </b-col>
                    <b-col class="d-flex align-items-center">
                        <input
                          id="file-upload"
                          type="file"
                          @change="handleFileInput"
                          accept="image/jpeg, image/png, image/webp"
                          hidden
                        />
                        <b-button variant="default" class="mt-10 fs-sa-14" :class="{'btn-upload-error' : $v.socials.wechat.qrcodeImage.$invalid && $v.socials.wechat.qrcodeImage.$dirty}" @click="browseFile">{{$t('engine.manageSocial.lblUploadQR', languageEngine)}}</b-button>
                        <small v-if="$v.socials.wechat.qrcodeImage.$invalid && $v.socials.wechat.qrcodeImage.$dirty" class="text-danger mt-5" style="margin-left: 16px;"> {{$t('engine.manageSocial.errUploadQR',languageEngine)}} </small>
                    </b-col>
                  </b-row>
                  <b-row v-if="socials['wechat']" class="mt-10">
                    <b-col cols="4">
                      <div class="fs-sa-12">{{$t('engine.manageSocial.lblShowQR', languageEngine)}}</div>
                      <div class="fs-sa-12 text-muted">({{$t('engine.manageSocial.lblShowQRHint', languageEngine)}})</div>
                    </b-col>
                    <b-col>
                      <b-form-checkbox v-model="socials['wechat'].isEnableQRcode"/>
                    </b-col>
                  </b-row>
                  <FormGroupHorizontal class="mt-gd-2" 
                    :label="$t('engine.manageSocial.lblColorWechat', languageEngine)"
                    :split="'4:auto'"
                    labelValign="center"
                    :contentClass="'position-relative'"
                  >
                    <PalettePicker :data="wechatColor" :boundary="'scrollParent'" @input="changeWechatColor"/>
                  </FormGroupHorizontal>
                </div>
              </div>
          </div>
          <template #overlay>
            <Loading :title="'Saving...'" />
          </template>
        </b-overlay>
      </template>
    <template #modal-footer>
      <b-button variant="blue" class="mr-2" @click="save($event)">
        <i class="far fa-check"></i> {{$t('engine.common.btnSave', languageEngine)}}
      </b-button>
      <b-button variant="secondary" @click="closeModal()">
        <i class="far fa-times"></i> {{$t('engine.common.btnCancel', languageEngine)}}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapGetters } from "vuex";
import { capitalize } from "@helpers/text.helper";
import TitleModal from "@components_system/Shared/Elements/Texts/TitleModal";
import TitleSetting from "@components_system/Shared/Elements/Texts/TitleSetting";
import Switcher from "@components_system/Shared/Tools/Switcher/Switcher";
import Loading from "@components_system/Shared/Tools/Loading/Loading";
import socialLine from "@sharedcomp/thumnailWidget/widget_social/line/line_square_multicolor.vue";
import socialWechat from "@sharedcomp/thumnailWidget/widget_social/wechat/wechat_square_multicolor.vue";
import socialService from "@services/socialService.js";
import { url  } from "vuelidate/lib/validators";
import FormGroupHorizontal from '@components_system/Shared/Tools/FormGroupHorizontal/FormGroupHorizontal';
import PalettePicker from "@components_system/Shared/Tools/PalettePicker/PalettePicker";

const components = {
  facebook_custom: () =>
    import(
      /* webpackChunkName: "facebook_custom" */ "@sharedcomp/thumnailWidget/widget_social/facebook/facebook_square_multicolor.vue"
    ),
  twitter_custom: () =>
    import(
      /* webpackChunkName: "twitter_custom" */ "@sharedcomp/thumnailWidget/widget_social/twitter/twitter_square_multicolor.vue"
    ),
  instagram_custom: () =>
    import(
      /* webpackChunkName: "instagram_custom" */ "@sharedcomp/thumnailWidget/widget_social/instagram/instagram_square_multicolor.vue"
    ),
  youtube_custom: () =>
    import(
      /* webpackChunkName: "youtube_custom" */ "@sharedcomp/thumnailWidget/widget_social/youtube/youtube_square_multicolor.vue"
    ),
  pinterest_custom: () =>
    import(
      /* webpackChunkName: "pinterest_custom" */ "@sharedcomp/thumnailWidget/widget_social/pinterest/pinterest_square_multicolor.vue"
    ),
  whatsapp_custom: () =>
    import(
      /* webpackChunkName: "whatsapp_custom" */ "@sharedcomp/thumnailWidget/widget_social/whatsapp/whatsapp_square_multicolor.vue"
    ),
  linkedin_custom: () =>
    import(
      /* webpackChunkName: "linkedin_custom" */ "@sharedcomp/thumnailWidget/widget_social/linkedin/linkedin_square_multicolor.vue"
    ),
  tiktok_custom: () =>
    import(
      /* webpackChunkName: "tiktok_custom" */ "@sharedcomp/thumnailWidget/widget_social/tiktok/tiktok_square_multicolor.vue"
    ),
  shopee_custom: () =>
    import(
      /* webpackChunkName: "shopee_custom" */ "@sharedcomp/thumnailWidget/widget_social/shopee/shopee_square_multicolor.vue"
    ),
  lineshop_custom: () =>
    import(
      /* webpackChunkName: "lineshop_custom" */ "@sharedcomp/thumnailWidget/widget_social/lineshop/lineshop_square_multicolor.vue"
    ),
  nocnoc_custom: () =>
    import(
      /* webpackChunkName: "nocnoc_custom" */ "@sharedcomp/thumnailWidget/widget_social/nocnoc/nocnoc_square_multicolor.vue"
    ),
  amazon_custom: () =>
    import(
      /* webpackChunkName: "amazon_custom" */ "@sharedcomp/thumnailWidget/widget_social/amazon/amazon_square_multicolor.vue"
    ),
  tokopedia_custom: () =>
    import(
      /* webpackChunkName: "tokopedia_custom" */ "@sharedcomp/thumnailWidget/widget_social/tokopedia/tokopedia_square_multicolor.vue"
    ),
};

const wechatImage = (value, vm) => {
  if (!vm.isEnableQRcode) return true;
  if (!value) {
    return false;
  }
  return true;
};

export default {
  components: {
    Switcher,
    TitleModal,
    TitleSetting,
    Loading,
    socialLine,
    socialWechat,
    socialService,
    FormGroupHorizontal,
    PalettePicker,
    ...components,
  },
  data() {
    return {
      isUploading: false,
      fileUpload: [],
      socials: undefined,
      socialStyle: undefined,
      socialsType: [
        "facebook",
        "twitter",
        "instagram",
        "youtube",
        "pinterest",
        "whatsapp",
        "linkedin",
        "tiktok",
        "shopee",
        "lazada",
        "lineshop",
        "nocnoc",
        "amazon",
        "tokopedia",
        "line",
        "wechat",
      ],
      socialsTypeSettingNormal: [
        "facebook",
        "twitter",
        "instagram",
        "youtube",
        "pinterest",
        "whatsapp",
        "linkedin",
        "tiktok",
        "shopee",
        "lazada",
        "lineshop",
        "nocnoc",
        "amazon",
        "tokopedia",
      ],
    };
  },
  computed: {
    ...mapGetters({
      languageEngine: "design/userPreference/languageEngine",
      siteData: "design/metadata/siteData",
      modal: "design/modal",
      siteComponents: "design/metadata/siteComponents",
    }),
    enableLine() {
      return this.siteData.DATA_SOCIAL.line.isEnable;
    },
    enableWechat() {
      return this.siteData.DATA_SOCIAL.wechat.isEnable;
    },
    lineColor() {
      return this.socialStyle.style.lineTextColor;
    },
    wechatColor() {
      return this.socialStyle.style.wechatTextColor;
    },
  },
  
  watch: {
    modal: {
      handler() {
        if (this.modal == "modal-manage-social") {
          this.$bvModal.show("modal-manage-social");
        }
      },
    },
  },
  methods: {
    capitalize,
    modalShow() {
      this.socials = JSON.parse(JSON.stringify(this.siteData.DATA_SOCIAL))
      this.socialStyle = JSON.parse(JSON.stringify(this.siteComponents.STYLE_WIDGET_SOCIAL))
      this.$v.$reset();
    },
    modalHidden() {
      this.socials = undefined;
      this.socialStyle = undefined;
      this.fileUpload = [];
      this.$v.$reset();
    },
    closeModal() {
      this.$bvModal.hide("modal-manage-social");
      this.$store.dispatch("design/setModal", { name: "" });
    },
    genUrlPlaceHolder(socialKey) {
      if (socialKey == 'whatsapp') {
        return 'https://www.wa.me/66123456789'
      } else if (socialKey == 'lineshop') {
        return 'https://shop.line.me'
      } else {
        return `https://www.${socialKey}.com`
      }
    },
    inputSocialKeyup(socialKey) {
      if (socialKey == 'line' || socialKey == 'wechat') {
        if (!this.socials[socialKey].username || this.socials[socialKey].username.length <= 0) {
          this.socials[socialKey].isEnable = false
        }
      } else {
        if (!this.socials[socialKey].link || this.socials[socialKey].link.length <= 0) {
          this.socials[socialKey].isEnable = false
        } else {
          if (this.$v.$invalid) {
            this.socials[socialKey].isEnable = false
          }
        }
      }
    },
    inputSocialOnBlur(socialKey) {
      if (!this.socials[socialKey].link || this.socials[socialKey].link.length <= 0) {
        this.socials[socialKey].isEnable = false
      }
    },
    toggleEnableSocial(value, socialKey) {
      if (this.$v.$invalid) {
        this.socials[socialKey].isEnable = false
      } else {
        this.socials[socialKey].isEnable = value
      }
    },
    inputLineOnBlur() {
      if (this.socials['line'].username.charAt(0) == '@') {
        this.socials['line'].username = this.socials['line'].username.slice(1)
      }
      this.socials['line'].username = this.socials['line'].username.toLowerCase()
    },
    browseFile() {
      document.getElementById('file-upload').click();
    },
    handleFileInput(e) {
      let file = e.target.files;
      if (file) {
        this.filterFile(file);
      }
    },
    filterFile(files) {
      this.fileUpload = [];
      [...files].forEach((file) => {
        const fileTypeValid = ['image/jpeg', 'image/png', 'image/webp']
        if (!fileTypeValid.includes(file.type)) {
          file.error = "ERROR_FILES_TYPE";
          file.status = "error";
          this.$toast.error({ title: this.$t("engine.common.alert.error.title", this.languageEngine), message: this.$t('engine.common.alert.upload.invalidFile', this.languageEngine) });
        } else if (file.size > 2000000) {
          file.error = "ERROR_FILES_SIZE";
          file.status = "error";
          this.$toast.error({ title: this.$t("engine.common.alert.error.title", this.languageEngine), message: this.$t('engine.common.alert.upload.fileExceed', this.languageEngine, {size:'2'}) });
        } else {
          this.fileUpload.push(file);
          this.socials.wechat.qrcodeImage = 'uploading';
          this.$toast.success({ title: this.$t("engine.common.alert.success.title", this.languageEngine), message: this.$t('engine.common.alert.upload.success', this.languageEngine) });
          file.status = "pending";
        }
      });
    },
    genUrlPreview(file) {
      const file_data = new File([file], file.name, { type: file.type });
      return URL.createObjectURL(file_data);
    },
    uploadQRandSave() {
      this.isUploading = true;
      this.fileUpload.filter((file) => !file.error).map((file) => {
        var formData = new FormData();
        formData.append("content", file);
        formData.append("type", "wechat");
        socialService.uploadQRcodeWechat(formData)
          .then((result) => {
            this.fileUpload = [];
            if (result) {
              this.socials.wechat.qrcodeImage = result.url;
              this.isUploading = false;
              this.siteData.DATA_SOCIAL = { ...this.socials };
              this.$store.dispatch("design/setModal", { name: "" });
              this.$store.dispatch("design/snapshot/genSnapshot");
              this.$bvModal.hide("modal-manage-social");
            }
          })
          .catch(() => {
            file.status = "error";
            file.error = "ERROR_UPLOAD_CANCEL";
            this.isUploading = false;
          });
      });
    },
    async save() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        return
      }
      if (this.fileUpload.length > 0) {
        await this.uploadQRandSave();
      } else {
        this.siteData.DATA_SOCIAL = { ...this.socials };
        this.siteComponents.STYLE_WIDGET_SOCIAL = { ...this.socialStyle };
        this.$store.dispatch("design/setModal", { name: "" });
        this.$store.dispatch("design/snapshot/genSnapshot");
        this.$bvModal.hide("modal-manage-social");
      }
      
    },
    changeLineColor(value) {
      this.socialStyle.style.lineTextColor = value;
    },
    changeWechatColor(value) {
      this.socialStyle.style.wechatTextColor = value;
    },
    lineStringUrlCheck() { 
      const rg = new RegExp(/((^(https|http|ftp)+(:))|(^(www)+([.])+\w+\/)|(^( ))|([:/,<>;%]))/gm)
      const isUrl = rg.test(this.socials['line'].username)
      // console.log(isUrl)
      if (isUrl) {
        this.socials['line'].isEnable = false
      }
      return isUrl
    },
  },
  validations: {
    socials: {
      facebook: {
        link: { url }
      },
      twitter: {
        link: { url }
      },
      instagram: {
        link: { url }
      },
      youtube: {
        link: { url }
      },
      pinterest: {
        link: { url }
      },
      whatsapp: {
        link: { url }
      },
      linkedin: {
        link: { url }
      },
      tiktok: {
        link: { url }
      },
      shopee: {
        link: { url }
      },
      lazada: {
        link: { url }
      },
      lineshop: {
        link: { url }
      },
      nocnoc: {
        link: { url }
      },
      amazon: {
        link: { url }
      },
      tokopedia: {
        link: { url }
      },
      line: {
        link: { url }
      },
      wechat: {
        link: { url },
        qrcodeImage : {wechatImage}
      },
    }
  },
  
};
</script>

<style lang="scss">
#modal-manage-social {
  .modal-header {
    padding: 20px 30px 15px 30px;
  }
  .modal-body {
    padding: 0;
    overflow-x: hidden;
    .setting-social {
      padding: 15px 0;
      .social-item {
        padding-left: 30px;
        padding-right: 30px;
        padding-bottom: 15px;
        .social-item-wrap {
          display: flex;
          align-items: center;
        }
      }
      .setting-line {
        color: #53585D;
        padding: 0 79px;
      }
      .setting-wechat {
        padding: 0 79px;
      }
    }
  }





  .colorFacebookBG {
    background: #4267b2;
    color: transparent;
  }
  .colorFacebook {
    color: #ffffff;
  }
  .facebookSocial:hover .colorFacebook {
    color: #ffffff;
  }
  .facebookSocial:hover .colorFacebookBG {
    background: #4267b2;
    color: transparent;
    filter: brightness(130%);
  }
  
  .colorTwitterBG {
    background: #1da1f2;
    color: transparent;
  }
  .colorTwitter {
    color: #ffffff;
  }
  .twitterSocial:hover .colorTwitterBG {
    background: #1da1f2;
    color: transparent;
    filter: brightness(130%);
  }
  .twitterSocial:hover .colorTwitter {
    color: #ffffff;
  }
  
  .colorInstagramBG {
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    );
    color: transparent;
  }
  .colorInstagram {
    color: #ffffff;
  }
  .instagramSocial:hover .colorInstagramBG {
    background: radial-gradient(
      circle at 30% 107%,
      #fdf497 0%,
      #fdf497 5%,
      #fd5949 45%,
      #d6249f 60%,
      #285aeb 90%
    );
    color: transparent;
    filter: brightness(130%);
  }
  .instagramSocial:hover .colorInstagram {
    color: #ffffff;
  }
  
  .colorGoogleplusBG {
    background: #db4437;
    color: transparent;
  }
  .colorGoogleplus {
    color: #ffffff;
  }
  .googleplusSocial:hover .colorGoogleplusBG {
    background: #db4437;
    color: transparent;
    filter: brightness(130%);
  }
  .googleplusSocial:hover .colorGoogleplus {
    color: #ffffff;
  }
  
  .colorYoutubeBG {
    background: #eb0808;
    color: transparent;
  }
  .colorYoutube {
    color: #ffffff;
  }
  .youtubeSocial:hover .colorYoutubeBG {
    background: #eb0808;
    color: transparent;
    filter: brightness(130%);
  }
  .youtubeSocial:hover .colorYoutube {
    color: #ffffff;
  }
  
  .colorPinterestBG {
    background: #bd081c;
    color: transparent;
  }
  .colorPinterest {
    color: #ffffff;
  }
  .pinterestSocial:hover .colorPinterestBG {
    background: #bd081c;
    color: transparent;
    filter: brightness(130%);
  }
  .pinterestSocial:hover .colorPinterest {
    color: #ffffff;
  }
  
  .colorLineBG {
    background: #00b800;
    color: transparent;
  }
  .colorLine {
    color: #ffffff;
  }
  .LineSocial:hover .colorLine {
    color: #ffffff;
  }
  .LineSocial:hover .colorLineBG {
    background: #00b800;
    color: transparent;
    filter: brightness(130%);
  }
  
  .colorWhatsappBG {
    color: #26d267;
  }
  .colorwhatapp {
    color: #ffffff;
  }
  .whatappSocial:hover .colorwhatapp {
    color: #ffffff;
  }
  .whatappSocial:hover .colorWhatsappBG {
    color: #5fe291;
  }
  .btn-upload-error {
    border-color : #D9544F
  }
}

</style>
